type CardProps = {
    title: string;
    subtitle?: string;
    description: string;
    icon: React.ReactNode;
}

const Card = (props: CardProps) => {
    return (
        <div className="bg-[#111a30] rounded-[15px] p-[20px] flex-1 md:min-w-[450px] md:max-w-[450px] min-w-[300px] max-w-[300px] min-h-[250px] relative flex flex-col">
            <div className="absolute top-[-50px] left-[50%] translate-x-[-50%]">{props.icon}</div>
            <div className="mt-[100px] flex-1 flex flex-col justify-start items-center text-center">
                <p className="text-[#fff] text-[18px] font-[800]">{props.title}</p>
                {props.subtitle && <p className="text-[#fff] text-[18px] font-[800]">{props.subtitle}</p>}
                <p className="text-[#B3BEC1] text-[16px] font-[800] my-[20px] px-[10px]">{props.description}</p>
            </div>
        </div>
    )
}

export default Card